var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 17.5002V20.8335M19.9996 24.1669H20.008M18.8457 13.2433L11.9917 25.0821C11.6115 25.7388 11.4214 26.0671 11.4495 26.3366C11.474 26.5716 11.5971 26.7852 11.7883 26.9242C12.0074 27.0835 12.3868 27.0835 13.1456 27.0835H26.8537C27.6125 27.0835 27.9919 27.0835 28.211 26.9242C28.4021 26.7852 28.5253 26.5716 28.5498 26.3366C28.5779 26.0671 28.3878 25.7388 28.0076 25.0821L21.1535 13.2433C20.7747 12.589 20.5853 12.2618 20.3382 12.152C20.1227 12.0561 19.8766 12.0561 19.6611 12.152C19.4139 12.2618 19.2245 12.589 18.8457 13.2433Z",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationError);
export default __webpack_public_path__ + "static/media/icon-notification-error.c152265cf618a619f8387d91e05b2415.svg";
export { ForwardRef as ReactComponent };